<template>
  <div class="map-container">
    <GisMap ref="gisMap" @feature-selected="handleFeatureSelected" />
    <div class="scaled-components" :style="containerStyle">
      <LegengMap ref="legengMap" @layer-click="handleLayerClick" @selected-id-change="handleSelectedIdChange" />
      <InfoMap ref="infoMap" :layerLeval="layerLeval" @close-overlay="handleCloseOverlay"
        @feature-selected="handleFeatureSelected" @update-zone-layer-filter="handleUpdateZoneLayerFilter"
        @show-child-zone-box="handleShowChildZoneBox" @hide-child-zone-box="handleCloseChildZoneBox"
        @update-zone-selector="handleUpdateZoneSelector" />
      <BottomMap @layer-change="handleLayerChange" @positioning="handlePositioning" @tool-click="handleToolClick"
        @show-legend="handleShowLegend" @layer-level-change="handleLayerLevelChange"
        @zone-name-change="handleZoneNameChange" @location-device="handleLocationDevice" :layerLeval="layerLeval" 
        :layerLevelList="layerLevelList" :zoneSelectList="zoneSelectList" :zoneNameAndValue="zoneNameAndValue"
        :currentZoneId="zoneId" />
      <Scalebar />
      <ToolContainer :visible="toolContainerVisible" :tool-list="currentToolList" :active-tool-type="activeToolType"
        @tool-item-click="handleToolItemClick" @delete-tool="handleDeleteTool" />
      <ChildZoneBox :visible="childZoneBoxShow" :zone-id="childZoneDataId" :zone-name="childZoneName"
        @close="handleCloseChildZoneBox" />
    </div>
  </div>
</template>

<script>
import GisMap from './newBigMapPartition/gisMap.vue';
import LegengMap from './newBigMapPartition/legengMap.vue';
import InfoMap from './newBigMapPartition/infoMap.vue';
import BottomMap from './newBigMapPartition/bottomMap.vue';
import Scalebar from './mapModule/Scalebar.vue';
import ToolContainer from './mapModule/ToolContainer.vue';
import ChildZoneBox from './newBigMapPartition/ChildZoneBox.vue';
import { getZoneMetering } from '@/api/manage'

export default {
  name: 'BigMapPartition',
  components: {
    GisMap,
    LegengMap,
    InfoMap,
    BottomMap,
    Scalebar,
    ToolContainer,
    ChildZoneBox
  },
  data () {
    return {
      layerLeval: 1, // 图层等级
      layerLevelList: [], // 图层等级列表
      zoneSelectList: [], // 片区选择列表
      zoneNameAndValue: [], // 当前选中的片区
      zoneMeteringList: [], // 所有片区数据
      zoneName: '', // 当前片区名称
      zoneId: '', // 当前片区ID
      // 屏幕适配相关数据
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      scaleRatio: 1,
      // 基准屏幕尺寸（设计稿尺寸）
      baseWidth: 1920,
      baseHeight: 1080,
      // 最小和最大缩放比例
      minScale: 0.5,
      maxScale: 2.0,
      // 工具容器相关数据
      toolContainerVisible: false,
      currentToolList: [],
      activeToolType: null,
      toolContainerTimer: null, // 工具容器监听定时器
      // 子分区框相关数据
      childZoneBoxShow: false,
      childZoneDataId: '',
      childZoneName: ''
    }
  },
  computed: {
    // 计算容器样式，包含缩放变换
    containerStyle () {
      return {
        transform: `scale(${this.scaleRatio})`,
        transformOrigin: 'top left',
        width: `${100 / this.scaleRatio}%`,
        height: `${100 / this.scaleRatio}%`
      };
    }
  },
  created () {
    // 可以根据路由参数或其他条件决定是否显示片区控制
    this.initZoneData();
  },
  mounted () {
    this.initScreenAdaptation();
    this.bindResizeEvent();
    // 监听工具容器状态变化
    this.watchToolContainer();
  },
  beforeDestroy () {
    this.unbindResizeEvent();
    // 清除工具容器监听
    if (this.toolContainerTimer) {
      clearInterval(this.toolContainerTimer);
    }
  },
  methods: {
    // 初始化屏幕适配
    initScreenAdaptation () {
      this.updateScreenSize();
      this.calculateScaleRatio();
    },

    // 更新屏幕尺寸
    updateScreenSize () {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },

    // 计算缩放比例
    calculateScaleRatio () {
      // 计算宽高比
      const widthRatio = this.screenWidth / this.baseWidth;
      const heightRatio = this.screenHeight / this.baseHeight;

      // 使用较小的比例确保内容完全显示
      let ratio = Math.min(widthRatio, heightRatio);

      // 限制在最小和最大缩放比例之间
      ratio = Math.max(this.minScale, Math.min(this.maxScale, ratio));

      this.scaleRatio = ratio;

      console.log('屏幕适配信息:', {
        screenSize: `${this.screenWidth}x${this.screenHeight}`,
        baseSize: `${this.baseWidth}x${this.baseHeight}`,
        scaleRatio: this.scaleRatio
      });
    },

    // 绑定窗口大小变化事件
    bindResizeEvent () {
      this.handleResize = this.debounce(() => {
        this.updateScreenSize();
        this.calculateScaleRatio();
      }, 100);

      window.addEventListener('resize', this.handleResize);
    },

    // 解绑窗口大小变化事件
    unbindResizeEvent () {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    },

    // 防抖函数
    debounce (func, wait) {
      let timeout;
      return function executedFunction (...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    // 监听工具容器状态
    watchToolContainer () {
      // 使用 setInterval 轮询检查状态（因为 watch 可能无法监听到深层属性）
      this.toolContainerTimer = setInterval(() => {
        this.updateToolContainerState();
      }, 100);
    },

    // 更新工具容器状态
    updateToolContainerState () {
      if (this.$refs.gisMap) {
        this.toolContainerVisible = this.$refs.gisMap.showToolContainer || false;
        this.currentToolList = this.$refs.gisMap.currentToolList || [];
        this.activeToolType = this.$refs.gisMap.activeToolType || null;
      }
    },

    // 处理工具项点击
    handleToolItemClick (item) {
      if (this.$refs.gisMap && this.$refs.gisMap.handleToolItemClick) {
        this.$refs.gisMap.handleToolItemClick(item);
        // 同步状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 处理删除工具
    handleDeleteTool () {
      if (this.$refs.gisMap && this.$refs.gisMap.handleDeleteTool) {
        this.$refs.gisMap.handleDeleteTool();
        // 同步状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 初始化片区数据
    async initZoneData () {
      try {
        // 获取图层等级选项
        const resLevel = await this.$http.get('/pipe-network/zone-metering/level/options');
        this.layerLevelList = resLevel.data || [];

        // 获取片区数据
        const { data } = await getZoneMetering();
        this.zoneMeteringList = data || [];
        this.setZoneNameList('1');
      } catch (error) {
        console.error('初始化片区数据失败:', error);
      }
    },

    // 根据等级设置片区列表
    async setZoneNameList (val) {
      this.zoneSelectList = [];
      this.zoneMeteringList.forEach(element => {
        if (element.level === val) {
          this.zoneSelectList.push(element);
        }
      });

      // if (this.zoneSelectList.length > 0) {
      //   this.zoneName = this.zoneSelectList[0].zoneName;
      //   this.zoneId = this.zoneSelectList[0].zoneId;
      //   // 使用对象格式，与 label-in-value 返回的格式一致
      //   this.zoneNameAndValue = { key: this.zoneId, label: this.zoneName };
        
      // }
    },

    // 处理图层等级变更
    async handleLayerLevelChange (val) {
      console.log('图层等级变更:', val);
      this.layerLeval = val;
      this.zoneNameAndValue = [];
      this.zoneId = '';
      this.zoneName = '';
      await this.setZoneNameList(val.toString());

      // 通知 GisMap 更新图层（内部会清除 loadZoneDevices 相关的图标和片区范围）
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerLevelChange) {
        this.$refs.gisMap.handleLayerLevelChange(val);
      }

      // 如果当前有选中的片区，仅重新加载该片区的设备数据，不移动视角
      // if (this.zoneId) {
      //   console.log('图层等级变更后，重新加载片区设备数据:', this.zoneId);
      //   await this.loadZoneDevices(this.zoneId);
      // }
    },

    // 处理片区选择变更
    async handleZoneNameChange (val) {
      console.log('片区选择变更:', val);
      this.zoneNameAndValue = val;
      this.zoneName = val.label;
      this.zoneId = val.key;

      // 获取该片区的设备数据并高亮显示
      await this.loadZoneDevices(val.key);

      // 通知 GisMap 定位到选中片区
      if (this.$refs.gisMap && this.$refs.gisMap.handleZoneNameChange) {
        this.$refs.gisMap.handleZoneNameChange(val);
      }
    },

    // 处理片区选择器更新事件（从 InfoMap 触发）
    async handleUpdateZoneSelector (zoneData) {
      console.log('更新片区选择器:', zoneData);
      // 更新 zoneNameAndValue，这会自动更新 BottomMap 中的选择器显示
      this.zoneNameAndValue = zoneData;
      this.zoneName = zoneData.label;
      this.zoneId = zoneData.key;

      // 重新加载该片区的设备数据并高亮显示
      if (zoneData.key) {
        console.log('重新加载片区设备数据:', zoneData.key);
        await this.loadZoneDevices(zoneData.key);
      }
    },

    // 加载片区设备数据
    async loadZoneDevices (zoneId) {
      try {
        // 并行请求两个接口
        const [remoteMetersRes, boundaryValvesRes] = await Promise.all([
          // 分区计量仪表
          this.$http.get('/pipe-network/remote-meters/rule/select', { params: { zoneId } }),
          // 分界阀门
          this.$http.get('/pipe-network/water_associated_points/list', { params: { zoneId } })
        ]);

        const remoteMeters = remoteMetersRes.data || [];
        const boundaryValves = boundaryValvesRes.data || [];

        console.log('分区计量仪表数据:', remoteMeters);
        console.log('分界阀门数据:', boundaryValves);

        // 通知 GisMap 高亮显示设备
        if (this.$refs.gisMap && this.$refs.gisMap.highlightZoneDevices) {
          this.$refs.gisMap.highlightZoneDevices({
            remoteMeters,
            boundaryValves
          });
        }
      } catch (error) {
        console.error('获取片区设备数据失败:', error);
        // this.$message.error('获取片区设备数据失败');
      }
    },

    // 处理设备定位事件
    handleLocationDevice (locationData) {
      console.log('处理设备定位:', locationData);
      
      // 通知 GisMap 定位到设备
      if (this.$refs.gisMap && this.$refs.gisMap.locationToDevice) {
        this.$refs.gisMap.locationToDevice(locationData);
      }
    },
    // 处理图层点击事件
    handleLayerClick (data) {
      console.log('图层点击:', data);
      // data 是一个对象，包含 { item, index, selected }
      // 将图层选择事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerSelected) {
        this.$refs.gisMap.handleLayerSelected(data);
      }
    },

    // 处理选中ID变化事件
    handleSelectedIdChange (data) {
      console.log('selectedID 变化:', data);
      // 将 selectedID 传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleSelectedIdChange) {
        this.$refs.gisMap.handleSelectedIdChange(data);
      }
    },

    // 处理底图变化事件
    handleLayerChange (data) {
      console.log('图层变化:', data);
      // 将图层数据传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerChange) {
        this.$refs.gisMap.handleLayerChange(data);
      }
    },

    // 处理清除图层事件
    handleClearLayer (layerId) {
      console.log('接收到清除图层事件:', layerId);
      // 将清除图层事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.clearLayerById) {
        this.$refs.gisMap.clearLayerById(layerId);
      }
    },

    // 处理要素选择事件
    handleFeatureSelected (feature) {
      console.log('要素选择事件:', feature);
      // 将要素数据传递给 InfoMap
      if (this.$refs.infoMap && this.$refs.infoMap.handleFeatureData) {
        this.$refs.infoMap.handleFeatureData(feature);
      }
    },

    // 处理关闭覆盖层事件
    handleCloseOverlay () {
      console.log('接收到关闭覆盖层事件');
      // 调用 GisMap 的关闭覆盖层方法
      if (this.$refs.gisMap && this.$refs.gisMap.handleCloseOverlay) {
        this.$refs.gisMap.handleCloseOverlay();
      }
    },

    // 处理更新片区范围示意图图层查询条件
    handleUpdateZoneLayerFilter (params) {
      console.log('接收到更新片区图层查询条件事件，params:', params);
      if (this.$refs.gisMap && this.$refs.gisMap.updateZoneMeteringLayerFilter) {
        // 如果 params 是对象，解构；如果是字符串，兼容旧格式
        if (typeof params === 'object' && params.zoneId !== undefined) {
          this.$refs.gisMap.updateZoneMeteringLayerFilter(params.zoneId, params.usePidStr);
        } else {
          // 兼容旧格式（字符串）
          this.$refs.gisMap.updateZoneMeteringLayerFilter(params, false);
        }
      }
    },

    // 处理定位事件
    handlePositioning () {
      console.log('接收到定位事件');
      // 调用 GisMap 的定位方法
      if (this.$refs.gisMap && this.$refs.gisMap.handlePositioning) {
        this.$refs.gisMap.handlePositioning();
      }
    },

    // 处理工具点击事件
    handleToolClick (key) {
      console.log('接收到工具点击事件:', key);
      // 将工具点击事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleToolClick) {
        this.$refs.gisMap.handleToolClick(key);
        // 同步工具容器状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 处理显示图例事件
    handleShowLegend () {
      console.log('接收到显示图例事件');
      // 调用 LegengMap 的显示图例方法
      if (this.$refs.legengMap && this.$refs.legengMap.handleShowLegend) {
        this.$refs.legengMap.handleShowLegend();
      }
    },

    // 获取地图实例
    getMap () {
      if (this.$refs.gisMap && this.$refs.gisMap.getBigMap) {
        return this.$refs.gisMap.getBigMap();
      }
      return null;
    },

    // 处理显示子分区框事件
    handleShowChildZoneBox (data) {
      // 如果传递了 toggle 标志，则切换显示状态
      if (data.toggle) {
        // 如果当前已显示且 zoneId 相同，则隐藏；否则显示并更新 zoneId
        if (this.childZoneBoxShow && this.childZoneDataId === data.zoneId) {
          this.childZoneBoxShow = false;
        } else {
          this.childZoneDataId = data.zoneId || '';
          this.childZoneName = data.zoneName || '';
          this.childZoneBoxShow = true;
        }
      } else {
        this.childZoneDataId = data.zoneId || '';
        this.childZoneName = data.zoneName || '';
        this.childZoneBoxShow = data.show !== undefined ? data.show : !this.childZoneBoxShow;
      }
    },

    // 处理关闭子分区框
    handleCloseChildZoneBox () {
      this.childZoneBoxShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.scaled-components {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; // 让点击事件穿透到地图
  z-index: 1000;

  // 确保子组件可以接收点击事件
  >* {
    pointer-events: auto;
  }
}

// 响应式断点
@media (max-width: 1920px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 1440px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 1024px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 768px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 480px) {
  .scaled-components {
    transform-origin: center center;
  }
}
</style>
